const axios = require("axios");

class IdpClient {
  idpService;
  idpServiceUrl;
  apiAccessToken;

  constructor(idpServiceUrl = process.env.IDP_SERVICE_URL, apiAccessToken = process.env.CENTIVO_IDP_ACCESS_TOKEN) {
    this.idpServiceUrl = idpServiceUrl;
    this.apiAccessToken = apiAccessToken;

    this.idpService = axios.create({
      baseURL: idpServiceUrl, 
      headers: {
        "content-type": "application/json",
        Authorization: this.apiAccessToken,
      }
    })
  }

  getSamlResponse(destination, user) {
    return this.idpService.post(
      '/getSamlResponse',
      {
        destination,
        user,
      },
    );
  }
}

module.exports = {
  IdpClient,
};
